import template from './booking-update.html';
import controller from './booking-update.controller';
import './booking-update.styl';

const bookingUpdateComponent = {
  template,
  controller,
  controllerAs: 'bookingUpdate',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

export default bookingUpdateComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-update/booking-update.component.js
 **/